/* Jouvana Paris — traduction espagnole des blocs personnalisés (chargé uniquement en /es) */
(function () {
  var D = {
    "Tableau des tailles": "Guía de tallas",
    "TABLEAU DES TAILLES": "GUÍA DE TALLAS",
    "Mesures données à titre indicatif, en centimètres.": "Medidas orientativas, en centímetros.",
    "Taille": "Talla",
    "TAILLE": "TALLA",
    "Poitrine": "Pecho",
    "Hanches": "Cadera",
    "Entre deux tailles ou coupe fluide préférée ? Privilégiez la taille supérieure pour plus de confort.": "¿Entre dos tallas o prefiere un corte holgado? Elija la talla superior para mayor comodidad.",
    "Livraison 5–7 j": "Envío 5–7 días",
    "Retours gratuits 30 j": "Devolución gratis 30 días",
    "Retours sous 30 j": "Devolución en 30 días",
    "Commandez avant": "Pide antes de las",
    ", expédition demain.": ", envío mañana.",
    "TENTEZ VOTRE CHANCE": "PRUEBA TU SUERTE",
    "Grattez pour voir ce que vous gagnez": "Rasca para ver lo que ganas",
    "sur toute la commande": "en todo el pedido",
    "Glissez votre doigt ou votre souris sur la carte": "Desliza tu dedo o el ratón sobre la tarjeta",
    "Utilisez ce code lors de votre commande :": "Usa este código al hacer tu pedido:",
    "Copier": "Copiar",
    "Copié !": "¡Copiado!",
    "J'en profite": "¡Lo quiero!",
    "GRATTEZ ICI": "RASCA AQUÍ",
    "OFFRE D'AUTOMNE": "OFERTA DE OTOÑO",
    "−50\u00a0% sur une sélection d'articles": "−50\u00a0% en una selección de artículos",
    "Mins": "Min",
    "Secs": "Seg",
    "🍂 Promotions d'automne : réduction progressive !": "🍂 Promociones de otoño: ¡descuento progresivo!",
    "Plusieurs articles au panier, la remise s'applique seule au paiement.": "Varios artículos en el carrito: el descuento se aplica solo al pagar.",
    "articles": "artículos",
    "MEILLEURE OFFRE": "MEJOR OFERTA",
    "Découvrir": "Descubrir",
    "Elles portent Jouvana": "Ellas llevan Jouvana",
    "Vos plus belles tenues, partagées par notre communauté": "Sus looks más bonitos, compartidos por nuestra comunidad",
    "COMPLÈTE LE LOOK": "COMPLETA EL LOOK",
    "−10 % sur toute la commande": "−10 % en todo el pedido",
    "COULEUR :": "COLOR:",
    "Ajouté à ta commande ✓": "Añadido a tu pedido ✓",
    "Choisis une taille disponible.": "Elige una talla disponible.",
    "Impossible de l'ajouter, réessaie.": "No se pudo añadir, inténtalo de nuevo.",
    "DERNIER LOT ÉPUISÉ EN 2 HEURES !": "¡ÚLTIMO LOTE AGOTADO EN 2 HORAS!",
    "Notre nouvelle collection vient d'arriver, et elle est plus belle que jamais ! Pour une durée limitée, profitez d'une réduction incroyable de 50% sur notre dernière collection. Ne manquez pas ces offres imbattables ! Profitez de vos articles préférés avant qu'ils ne disparaissent !": "Nuestra nueva colección acaba de llegar, ¡y es más bonita que nunca! Por tiempo limitado, aproveche un increíble descuento del 50% en nuestra última colección. ¡No se pierda estas ofertas inmejorables! ¡Consiga sus artículos favoritos antes de que se agoten!",
    "COMMANDEZ MAINTENANT AVANT QU'IL NE SOIT TROP TARD !": "¡PIDA AHORA ANTES DE QUE SEA DEMASIADO TARDE!",
    "Discover the Future of Hair Removal with IPL Laser Technology.": "Descubre el futuro de la depilación con tecnología láser IPL.",
    "Nos ensembles taillent normalement. Si vous hésitez entre deux tailles, privilégiez la taille supérieure pour un confort optimal, surtout si vous préférez une coupe plus fluide. Consultez notre guide des tailles ou contactez-nous pour un conseil personnalisé !": "Nuestras prendas tienen un tallaje normal. Si duda entre dos tallas, elija la superior para una mayor comodidad, sobre todo si prefiere un corte más holgado. ¡Consulte nuestra guía de tallas o contáctenos para recibir un consejo personalizado!",
    "Nous livrons dans la plupart des pays du monde. Nous nous efforçons de traiter et d'expédier les commandes sous 1 à 3 jours ouvrés. Le délai de livraison est généralement de 6 à 10 jours ouvrés après traitement de la commande. Consultez notre politique de livraison pour plus d'informations.": "Realizamos envíos a la mayoría de los países del mundo. Nos esforzamos por procesar y enviar los pedidos en un plazo de 1 a 3 días hábiles. El plazo de entrega suele ser de 6 a 10 días hábiles tras el procesamiento del pedido. Consulte nuestra política de envíos para más información.",
    "Oui, nous livrons partout dans le monde. Nous livrons actuellement dans plus de 65 pays. Des frais de livraison peuvent s'appliquer et seront ajoutés au moment du paiement.": "Sí, realizamos envíos a todo el mundo. Actualmente enviamos a más de 65 países. Pueden aplicarse gastos de envío, que se añadirán en el momento del pago.",
    "Nous proposons actuellement": "Actualmente ofrecemos",
    "Livraison gratuite pour les commandes supérieures à 60 €": "Envío gratuito en pedidos superiores a 60 €",
    "Toutes les commandes sont traitées dans les délais impartis.": "Todos los pedidos se procesan dentro de los plazos previstos.",
    "24 heures après la validation": "24 horas después de la validación",
    "BEST-SELLERS": "MÁS VENDIDOS",
    "Combien de temps faudra-t-il pour que ma commande arrive?": "¿Cuánto tardará en llegar mi pedido?",
    "Description": "Descripción",
    "FAQs": "Preguntas frecuentes",
    "Information Livraison": "Información de entrega",
    "LIVRAISON EN FRANCE": "ENTREGA EN FRANCIA",
    "Livrez-vous à l'international ?": "¿Realizan envíos internacionales?",
    "Presque épuisé": "Casi agotado",
    "Quelle taille choisir si je suis entre deux mesures ?": "¿Qué talla elegir si estoy entre dos medidas?",
    "Questions fréquentes": "Preguntas frecuentes",
    "REFLETS DORÉS": "REFLEJOS DORADOS",
    "REJOIGNEZ PLUS DE 20 000 CLIENTS SATISFAITS": "ÚNASE A MÁS DE 20 000 CLIENTES SATISFECHOS",
    "Return Policy": "Política de devoluciones",
    "SATISFAIT OU REMBOURSÉ": "SATISFECHO O REEMBOLSADO",
    "ESSAYEZ-LE SANS RISQUE PENDANT 30 JOURS": "PRUÉBELO SIN RIESGO DURANTE 30 DÍAS",
    "Couleur": "Color",
    "Pointure": "Talla",
    "Noir": "Negro",
    "Blanc": "Blanco",
    "Marron": "Marrón",
    "Gris": "Gris",
    "Rose": "Rosa",
    "Bleu": "Azul",
    "Bleu marine": "Azul marino",
    "Marine": "Marino",
    "Vert": "Verde",
    "Rouge": "Rojo",
    "Bordeaux": "Burdeos",
    "Jaune": "Amarillo",
    "Kaki": "Caqui",
    "Écru": "Crudo",
    "Crème": "Crema",
    "Chocolat": "Chocolate",
    "Violet": "Morado",
    "Orange": "Naranja",
    "Doré": "Dorado",
    "Argent": "Plateado",
    "Fermer": "Cerrar",
    "Précédent": "Anterior",
    "Suivant": "Siguiente"
  };
  var P = [[/^AJOUTER AVEC (.+)$/, "AÑADIR CON $1"]];

  function tr(s) {
    var t = s.replace(/\s+/g, " ").trim();
    if (!t) return null;
    if (D.hasOwnProperty(t)) return D[t];
    for (var i = 0; i < P.length; i++) if (P[i][0].test(t)) return t.replace(P[i][0], P[i][1]);
    return null;
  }

  // Texte dessiné dans un <canvas> (carte à gratter)
  var ft = CanvasRenderingContext2D.prototype.fillText;
  CanvasRenderingContext2D.prototype.fillText = function (txt) {
    var r = typeof txt === "string" ? tr(txt) : null;
    if (r) arguments[0] = r;
    return ft.apply(this, arguments);
  };

  function fixText(n) {
    var p = n.parentNode;
    if (!p || /^(SCRIPT|STYLE|TEXTAREA)$/.test(p.nodeName)) return;
    var v = n.nodeValue, r;
    // Colonne "Taille" (tour de taille) du tableau des tailles
    if (p.nodeName === "TH" && v.trim() === "Taille" && p.parentNode && p.parentNode.children[2] === p) r = "Cintura";
    else r = tr(v);
    if (r) {
      var lead = v.match(/^\s*/)[0], trail = v.match(/\s*$/)[0];
      n.nodeValue = lead + r + trail;
    }
  }
  function fixAttrs(el) {
    ["aria-label", "placeholder", "title"].forEach(function (a) {
      var v = el.getAttribute && el.getAttribute(a);
      var r = v && tr(v);
      if (r) el.setAttribute(a, r);
    });
  }
  function walk(root) {
    if (root.nodeType === 3) return fixText(root);
    if (root.nodeType !== 1) return;
    fixAttrs(root);
    var w = document.createTreeWalker(root, NodeFilter.SHOW_TEXT | NodeFilter.SHOW_ELEMENT, null);
    var n;
    while ((n = w.nextNode())) n.nodeType === 3 ? fixText(n) : fixAttrs(n);
  }
  function start() {
    walk(document.body);
    new MutationObserver(function (ms) {
      ms.forEach(function (m) {
        if (m.type === "characterData") fixText(m.target);
        else m.addedNodes.forEach(walk);
      });
    }).observe(document.body, { childList: true, subtree: true, characterData: true });
  }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", start);
  else start();
})();
